// extracted by mini-css-extract-plugin
module.exports = {"floatRightbarWrap":"App_floatRightbarWrap__JY7v3","customerService":"App_customerService__bG3E_","survey":"App_survey__2jtzX"};